// extracted by mini-css-extract-plugin
export default {"manage-button":"_2WqSx","manageButton":"_2WqSx"};